/**
 * See subtractBorder.css for explanation
 */
export const paddingMinusBorder = {
  '2xs': 'p-[calc(theme(padding.2xs)-var(--subtract-border-size))]',
  xs: 'p-[calc(theme(padding.xs)-var(--subtract-border-size))]',
};
